import React from "react";

const TypingIndicator = () => {
  return (
    <div
      className="self-start flex items-center gap-1.5 animate-slideInLeft"
      style={{
        maxWidth: '80%',
        padding: '12px 16px',
        margin: '8px 0',
        borderRadius: '20px',
        borderBottomLeftRadius: '4px',
        backgroundColor: '#F3F4F6',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
      }}
      aria-label="Assistant is typing"
      role="status"
    >
      {[0, 0.2, 0.4].map((delay, i) => (
        <span
          key={i}
          className="animate-typingDots"
          style={{
            display: 'inline-block',
            width: '7px',
            height: '7px',
            borderRadius: '50%',
            backgroundColor: 'var(--color-primary)',
            opacity: 0.4,
            animationDelay: `${delay}s`,
          }}
        />
      ))}
    </div>
  );
};

export default TypingIndicator;
